import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { accountCheck } from "../../services/eventService";
import { organizationDetails } from "../../services/organizationService";

const initialState = {
  themeSettings: {
    loading: true,
    data: null,
    error: null,
  },
};

export const getThemeSettings = createAsyncThunk(
  "organizerTheme/getThemeSettings",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await organizationDetails(payload);
      if (res?.data?.status === 200) {
        return res?.data;
      } else {
        return rejectWithValue(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const organizerThemeSlice = createSlice({
  name: "organizerTheme",
  initialState,
  reducers: {
    setOrganizerTheme: (state, action) => {
      state.themeSettings.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getThemeSettings.pending, (state) => {
        state.themeSettings.loading = true;
        state.themeSettings.data = false;
      })
      .addCase(getThemeSettings.fulfilled, (state, action) => {
        state.themeSettings.loading = false;
        state.themeSettings.data = action?.payload;
      })
      .addCase(getThemeSettings.rejected, (state, action) => {
        state.themeSettings.loading = false;
        state.themeSettings.data = null;
        state.themeSettings.error = action.payload;
      });
  },
});

export const { setOrganizerTheme } = organizerThemeSlice?.actions;
export default organizerThemeSlice?.reducer;
